const config = {
  API_URL: process.env.NODE_ENV === 'production'
    ? 'https://api.playsmarter.app'  // Production Worker URL
    : 'http://localhost:8787'        // Local Worker URL
};

export default config;